<div>
  <div class="loading-overlay loading-overlay--fixed"></div>

  <div
    [ngClass]="{ 'modal--show': popupOpen, 'modal--hide': !popupOpen }"
    class="modal"
    >
    <div class="modal-background"></div>

    <div class="modal-container" id="modal-new-claim">
      @if (!claimSuccess) {
        <div>
          <h1
            class="modal-title"
            i18n="Start a new claim@@claims.new.claim.button"
            >
          New claim
        </h1>
          <p class="modal-intro">
            <span i18n="New claim info text@@claims.new.claim.info.text">
            Submit claim for {{ data.articleDescription }}</span
              >&nbsp; {{ getAmountDescription() }}
            </p>
            @if (isErrorResponse) {
              <span>{{ claimResponse.errorMessage }}</span>
            }
            @if (!claimSuccess) {
              <form
                (ngSubmit)="onSubmit(newClaimForm.value)"
                [formGroup]="newClaimForm"
                enctype="multipart/form-data"
                >
                <div class="form-row">
                  <label for="type" i18n="@@claims.type.label">Type</label
                    ><span>*</span>
                    <div class="custom-control-group">
                      @for (claimCategory of getClaimTypes(); track claimCategory) {
                        <div
                          class="custom-control custom-radio"
                          >
                          <label>
                            <input
                              [value]="claimCategory"
                              formControlName="type"
                              id="type"
                              name="type"
                              type="radio"
                              />
                            <span class="checkbox-icon"></span>
                            <ng-container>
                              <span>{{ getClaimCategoryTitle(claimCategory) }}</span>
                            </ng-container>
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="form-row">
                    <label for="reason" i18n="@@claims.reason.label">Reason</label
                      ><span>*</span>
                      @if (categoryReasons.length < 1) {
                        <div
                          class="custom-select"
                          >
                          <select id="emptyreason" name="reason">
                            <option
                              disabled
                              i18n="@@claims.reasons.default.option.text"
                              selected
                              value=""
                              >
                  Choose a type first
                </option>
                          </select>
                        </div>
                      } @else {
                        <div class="custom-select">
                          <select formControlName="reason" id="reason" name="reason">
                            <option
                              disabled
                              i18n="@@claims.reasons.select.option.text"
                              selected
                              value=""
                              >
                    Select a reason for the claim
                  </option>
                            @for (reason of categoryReasons; track reason) {
                              <option
                                [ngValue]="reason.code"
                                >
                                {{ reason.codeDescription }}
                              </option>
                            }
                          </select>
                        </div>
                      }
                    </div>
                    @if (showQuantityField) {
                      <div class="form-row">
                        <label for="quantity" i18n="@@claims.amount.label">Amount</label
                          ><span>*</span>
                          <div class="custom-control">
                            <input
                              (input)="changeQuantity()"
                              [attr.min]="0"
                              autocomplete="off"
                              class="quantity-input_input"
                              formControlName="quantity"
                              id="quantity"
                              type="number"
                              />
                          </div>
                        </div>
                      }
                      @if (showPicturesField) {
                        <div class="form-row">
                          <label
                            [ngClass]="{ invalid: picturesInputInvalid }"
                            for="pictures"
                            i18n="@@claims.pictures.label"
                            >Upload your photo(s) here</label
                            ><span>*</span>
                            <file-pond
                              #claimImagesUpload
                              [options]="claimFilePondOptions"
                              id="pictures"
                            ></file-pond>
                            <span
                              class="picture-upload_disclaimer"
                              i18n="@@new.claim.picture.disclaimer"
                              >Disclaimer: make sure no personal data is visible in the
              photo(s).</span
                              >
                            </div>
                          }
                          <div class="form-row claim-description">
                            <label for="comment" i18n="@@claims.comment.label"
                              >Extra comment</label
                              >
                              <textarea
                                formControlName="comment"
                                i18n-placeholder="@@add.comment.placeholder.text"
                                id="comment"
                                maxlength="250"
                                placeholder="Type your comment here"
                                >
                              </textarea>
                              <span
                                class="character-limit"
                                i18n="max characters@@claims.max.characters.comment"
                                >max. 250 characters</span
                                >
                              </div>
                              <div class="form-row">
                                <label for="solution" i18n="@@claims.solutions.label"
                                  >How do you want us to solve it</label
                                  ><span>*</span>
                                  <div class="custom-select">
                                    <select formControlName="solution" id="solution" name="solution">
                                      <option
                                        disabled
                                        i18n="@@claims.solutions.select.option.text"
                                        selected
                                        value=""
                                        >
                  Select a desired solution for the claim
                </option>
                                      @for (solution of claimSolutions; track solution) {
                                        <option
                                          [ngValue]="solution.code"
                                          >
                                          {{ solution.description }}
                                        </option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                @if (showDifferentSolutionField) {
                                  <div
                                    class="form-row claim-description"
                                    >
                                    <label for="solutionText" i18n="@@claims.solutions.text.label"
                                      >Describe desired solution</label
                                      ><span>*</span>
                                      <textarea
                                        formControlName="solutionText"
                                        i18n-placeholder="@@add.solutions.placeholder.text"
                                        id="solutionText"
                                        maxlength="250"
                                        placeholder="Describe your desired solution here"
                                        >
                                      </textarea>
                                      <span
                                        class="character-limit"
                                        i18n="max characters@@claims.max.characters.comment"
                                        >max. 250 characters</span
                                        >
                                      </div>
                                    }
                                    <div class="button-bar button-bar--right">
                                      <button
                                        (click)="close()"
                                        class="button theme-btn-primary"
                                        i18n="@@close.comment.button"
                                        type="button"
                                        >
              Close
            </button>
                                      <button
                                        [disabled]="!submitClaimButtonActive()"
                                        class="button button--green theme-btn-success"
                                        i18n="@@claims.submit.claim.button"
                                        type="submit"
                                        >
              Submit claim
            </button>
                                    </div>
                                  </form>
                                }
                              </div>
                            }
                            @if (claimSuccess) {
                              <div>
                                <h4
                                  class="modal-intro"
                                  i18n="New claim info text@@claims.new.claim.info.successful"
                                  style="font-size: 18px; margin-bottom: 30px; text-align: center"
                                  >
          Your claim has been successfully submitted
        </h4>
                                <div class="button-bar button--claim-success">
                                  <button
                                    [routerLink]="['/my/claims']"
                                    class="button theme-btn-primary button--claim-success"
                                    i18n="@@claims.overview.button"
                                    type="button"
                                    >
            To claim list
          </button>
                                  <button
                                    [routerLink]="['/products']"
                                    class="button theme-btn-primary button--claim-success"
                                    i18n="@@claims.webshop.button"
                                    type="button"
                                    >
            To the webshop
          </button>
                                  <button
                                    (click)="close()"
                                    class="button theme-btn-primary button--claim-success"
                                    i18n="@@claims.another.claim.button"
                                    type="button"
                                    >
            Submit another claim
          </button>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
